import { render, staticRenderFns } from "./ContentProfileSelector.vue?vue&type=template&id=9f566c4a&scoped=true"
import script from "./ContentProfileSelector.vue?vue&type=script&lang=js"
export * from "./ContentProfileSelector.vue?vue&type=script&lang=js"
import style0 from "./ContentProfileSelector.vue?vue&type=style&index=0&id=9f566c4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f566c4a",
  null
  
)

export default component.exports